import React from "react";
import { useLocation } from "react-router-dom";
import { isValidSessionType } from "./sessionTypes";
import MeetingBody from "./MeetingBody";
import InterviewBody from "./InterviewBody";
import EkycBody from "./EkycBody";
import HealthcareBody from "./HealthcareBody";

const useQuery = () => new URLSearchParams(useLocation().search);

// The one entry point for every live-call type — Meeting, Interview, eKYC,
// Healthcare — reached at /session-room?type=... . SessionRoom itself does
// nothing but pick which Body to render; each Body owns its own params,
// Jitsi mount (via the shared JitsiSession), and dock (via the shared
// SessionDock or, for Meetings, LiveTranscriptPanel). See
// SessionRoom/sessionTypes.js for the per-type config, and the plan this
// was built from for the full rationale.
export default function SessionRoom() {
  const type = useQuery().get("type");

  if (!isValidSessionType(type)) {
    return (
      <div style={{ height: "100vh", width: "100vw", background: "#06101F", display: "flex",
        alignItems: "center", justifyContent: "center", color: "#7A93B4", fontFamily: "Outfit,sans-serif" }}>
        Unknown session type{type ? `: "${type}"` : ""} — this link looks invalid.
      </div>
    );
  }

  if (type === "meeting")    return <MeetingBody />;
  if (type === "interview")  return <InterviewBody />;
  if (type === "ekyc")       return <EkycBody />;
  if (type === "healthcare") return <HealthcareBody />;
  return null;
}
